import { render, staticRenderFns } from "./dialog-properties.vue?vue&type=template&id=fe90aa3a&scoped=true"
import script from "./dialog-properties.ts?vue&type=script&lang=ts&external"
export * from "./dialog-properties.ts?vue&type=script&lang=ts&external"
import style0 from "./dialog-properties.less?vue&type=style&index=0&id=fe90aa3a&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe90aa3a",
  null
  
)

export default component.exports